module.exports = __webpack_public_path__ + "img/empty.429b806a.svg";